import React, { useEffect } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";

const SideMenu = (props) => {
  return (
    <div className="sidemenu">
      <div className="sidemenu-item">
        <NavLink
          style={{
            textDecoration: "none",
            color: "#0050B5",
            fontWeight: "bold",
          }}
          activeStyle={{
            backgroundColor: "#fff",
            borderBottomWidth: "0.5px",
            borderBottomStyle: "solid",
            borderBottomColor: "#e3e3e3",
          }}
          to="/edetail-manager"
        >
          <p className="item"> E-Detail Manager</p>
        </NavLink>
      </div>
      <div className="sidemenu-item">
        <NavLink
          style={{
            textDecoration: "none",
            color: "#0050B5",
            fontWeight: "bold",
          }}
          activeStyle={{
            backgroundColor: "#fff",
            borderBottomWidth: "0.5px",
            borderBottomStyle: "solid",
            borderBottomColor: "#e3e3e3",
          }}
          to="/template-manager"
        >
          <p className="item">Template Manager1</p>
        </NavLink>
      </div>
    </div>
  );
};

export default SideMenu;
